var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("stock-compute-title")))]),
      _c(
        "w-list",
        [
          _vm._l(_vm.config.Stocks, function (stock, i) {
            return _c(
              "w-list-item",
              { key: i },
              [
                _c(
                  "w-list-item-text",
                  [
                    _c("w-col", { attrs: { xs: "10" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.getStockLocationName(stock)) + " "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.edit"),
                            expression: "$ct('common.edit')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.editStockConfig(i)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.delete"),
                            expression: "$ct('common.delete')",
                          },
                        ],
                        staticClass: "danger",
                        on: {
                          click: function ($event) {
                            return _vm.removeStockConfig(i)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              attrs: { disabled: _vm.config.Stocks.length >= 9 },
              on: {
                click: function ($event) {
                  return _vm.addStockComputeItem()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [
                _vm._v(" " + _vm._s(_vm.$t("common.add")) + " "),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditConf != undefined } },
        [
          _vm.toEditConf
            ? _c("app-edit-per-document-stock-settings-modal", {
                attrs: { value: _vm.toEditConf },
                on: {
                  input: function ($event) {
                    return _vm.onEditConfInput($event)
                  },
                  close: function ($event) {
                    _vm.toEditConfIndex = -1
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }